import { t } from "@lingui/core/macro";
import { atom } from "jotai";

import {
  _isNewEventSignUpAtom,
  currentSignUpRowAtom,
  isCurrentSignUpOnWaitlistAtom,
  primaryChargeRuleIdtoPriceMapAtom,
} from "../../eventSignUpProcess";
import { eventRemainingCapacityAtom } from "../../stores";

/**
 * We use this to warn users when they have gone over attendance capacity and will end up on th waitlist.
 * This is only relevant for NEW sign ups.
 */
export const waitlistWarningMessageAtom = atom((get) => {
  const signUpRow = get(currentSignUpRowAtom);
  const isNewSignUp = get(_isNewEventSignUpAtom);
  const numberOfPlayersInSignUp = signUpRow?.registrations.length ?? 0;
  const eventRemainingCapacity = get(eventRemainingCapacityAtom);
  const hasEligibleCharge = get(primaryChargeRuleIdtoPriceMapAtom).length > 0;

  if (!get(isCurrentSignUpOnWaitlistAtom)) {
    return null;
  }

  const remainingCapacity = eventRemainingCapacity?.remainingCapacity;
  const hasCapacityWarning =
    isNewSignUp &&
    eventRemainingCapacity?.capacityType === "ATTENDEES" &&
    remainingCapacity !== undefined &&
    numberOfPlayersInSignUp > remainingCapacity;

  if (hasCapacityWarning && remainingCapacity > 0) {
    return hasEligibleCharge
      ? t`There are only ${remainingCapacity} spots left for this event. You will be added to the waitlist. You will not be charged automatically; staff will charge you manually if you move off the waitlist.`
      : t`There are only ${remainingCapacity} spots left for this event. You will be added to the waitlist.`;
  }

  return hasEligibleCharge
    ? t`You will be added to the waitlist. You will not be charged automatically; staff will charge you manually if you move off the waitlist.`
    : t`You will be added to the waitlist.`;
});
